/**
 * Accessible footer newsletter modal and subscription states.
 */
function initNewsletter() {
  const modal = document.getElementById('adry-newsletter-modal');
  const form = modal ? modal.querySelector('[data-adry-newsletter-form]') : null;
  if (!modal || !form || !window.adryNewsletter) return;

  const dialog = modal.querySelector('.newsletter-modal__dialog');
  const email = form.querySelector('input[name="email"]');
  const submit = form.querySelector('button[type="submit"]');
  const message = form.querySelector('[data-adry-newsletter-message]');
  const triggers = Array.from(document.querySelectorAll('[data-adry-newsletter-open]'));
  const closers = Array.from(modal.querySelectorAll('[data-adry-newsletter-close]'));
  let lastFocused = null;

  function focusable() {
    return Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
  }

  function open(event) {
    if (event) event.preventDefault();
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('newsletter-modal-open');
    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      email.focus();
    });
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('newsletter-modal-open');
    window.setTimeout(() => {
      modal.hidden = true;
      if (lastFocused) lastFocused.focus();
    }, 220);
  }

  function showMessage(type, text) {
    message.className = `newsletter-modal__message is-${type}`;
    message.textContent = text;
  }

  function setLoading(loading) {
    submit.disabled = loading;
    form.classList.toggle('is-loading', loading);
    form.setAttribute('aria-busy', String(loading));
  }

  triggers.forEach((trigger) => trigger.addEventListener('click', open));
  closers.forEach((closer) => closer.addEventListener('click', close));

  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusable();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    message.textContent = '';
    message.className = 'newsletter-modal__message';
    if (!email.value || !email.validity.valid) {
      showMessage('error', window.adryNewsletter.messages.invalid);
      email.focus();
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(window.adryNewsletter.ajaxUrl, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
      const data = await response.json();
      if (data.success) {
        const code = data.data && data.data.code;
        showMessage(code === 'already_subscribed' ? 'info' : 'success', data.data.message);
        if (code !== 'already_subscribed') form.reset();
      } else {
        showMessage('error', data.data && data.data.message ? data.data.message : window.adryNewsletter.messages.error);
      }
    } catch (error) {
      showMessage('error', window.adryNewsletter.messages.error);
    } finally {
      setLoading(false);
    }
  });
}

export { initNewsletter };
